import React, { useState } from 'react'
 
 
import FuelRefillingList from './FuelRefillingList';
import FuelRefillingForm from './FuelRefillingForm';

const FuelRefilling= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <FuelRefillingForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <FuelRefillingList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}  
    </>
  )
}

export default FuelRefilling